/**
 * Cart Icon Button - Header cart icon with item count badge
 * Matches Front Desk design: ocean blue primary, Space Grotesk headings
 */
import { ShoppingCart } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { useCart } from '@/contexts/CartContext';

export function CartIconButton({ onClick }) {
  const { cart } = useCart();
  const itemCount = cart.item_count || 0;

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={onClick}
      className="relative transition-colors duration-200"
      data-testid="cart-icon-button"
      aria-label={`Shopping cart with ${itemCount} items`}
    >
      <ShoppingCart className="w-5 h-5" strokeWidth={1.5} />
      {itemCount > 0 && (
        <Badge
          className="absolute -top-1 -right-1 h-5 min-w-[20px] flex items-center justify-center px-1 bg-primary text-primary-foreground border-0 text-xs tabular-nums"
          data-testid="cart-item-count-badge"
        >
          {itemCount > 99 ? '99+' : itemCount}
        </Badge>
      )}
    </Button>
  );
}
